import React, { useState, useEffect } from "react";
import "./Footer.css";
import {
  FaInstagram,
  FaLocationDot,
  FaSquareFacebook,
  FaTiktok,
  FaXTwitter,
} from "react-icons/fa6";
import { IoLogoWhatsapp } from "react-icons/io";
import { FaYoutube } from "react-icons/fa";
import { FaSnapchat } from "react-icons/fa";
import myImage from "../../Images/Logo.png";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const isArabic = currentLanguage === "ar";
  const { settings } = useSelector((state) => state.usersSlice);


  return (
    <div
      className={`footer ${"visible"}`}
      style={{ position: "relative", bottom: "0", height: "auto" }}
    >
      <div className="footer-content">
        <div className="footerLogo">
          <img
            src={myImage}
            alt="Company Logo"
            className="logo-image2"
            style={{ borderRadius: "8px" }}
          />
        </div>
        <div className="line"></div>

        <div className="footer-text" style={{minWidth:"45%"}}>
       <div> {t('ownerName')} : { isArabic ? settings?.company_name : settings?.company_nameEn} </div>

       <div> {t('taxNumber')} : {settings?.commercial_number}</div>

       <div>
  {t('email')} :{' '}
  <a href={`mailto:${settings?.email}`} style={{ color: '#fff', textDecoration: 'underline', cursor: 'pointer' }}>
    {settings?.email}
  </a>
</div>
       <div> {t('phoneNumber')} : {settings?.whatsapp_number} </div>

        </div>

       
      </div>

       <div className="footer-icons">
          <a
            href={settings?.instagram_link}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              if (!settings?.instagram_link) {
                e.preventDefault();
                // Optional: Add toast notification or error handling
                console.error("Instagram link is not defined");
              }
            }}
          >
            <FaInstagram
              color="#fff"
              size={24}
              style={{ cursor: "pointer" }}
              className="hover:opacity-80 transition-opacity" // Optional hover effect
            />
          </a>
          <a
            href={settings?.whatsapp_link}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              if (!settings?.whatsapp_link) {
                e.preventDefault();
                // Optional: Add toast notification or error handling
                console.error("Whatsapp link is not defined");
              }
            }}
          >
            <IoLogoWhatsapp
              color="#fff"
              size={24}
              style={{ cursor: "pointer" }}
              className="hover:opacity-80 transition-opacity" // Optional hover effect
            />
          </a>
          <a
            href={settings?.snapchat_link}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              if (!settings?.snapchat_link) {
                e.preventDefault();
                // Optional: Add toast notification or error handling
                console.error("Snapchat link is not defined");
              }
            }}
          >
            <FaSnapchat
              color="#fff"
              size={24}
              style={{ cursor: "pointer" }}
              className="hover:opacity-80 transition-opacity" // Optional hover effect
            />
          </a>

          <a
            href={settings?.tiktok_link}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              if (!settings?.tiktok_link) {
                e.preventDefault();
                // Optional: Add toast notification or error handling
                console.error("Tiktok link is not defined");
              }
            }}
          >
            <FaTiktok
              color="#fff"
              size={24}
              style={{ cursor: "pointer" }}
              className="hover:opacity-80 transition-opacity" // Optional hover effect
            />
          </a>
          <a
            href={settings?.x_link}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              if (!settings?.x_link) {
                e.preventDefault();
                // Optional: Add toast notification or error handling
                console.error("X link is not defined");
              }
            }}
          >
            <FaXTwitter
              color="#fff"
              size={24}
              style={{ cursor: "pointer" }}
              className="hover:opacity-80 transition-opacity" // Optional hover effect
            />
          </a>
          <a
            href={settings?.location_link}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              if (!settings?.location_link) {
                e.preventDefault();
                // Optional: Add toast notification or error handling
                console.error("Location link is not defined");
              }
            }}
          >
            <FaLocationDot
              color="#fff"
              size={24}
              style={{ cursor: "pointer" }}
              className="hover:opacity-80 transition-opacity" // Optional hover effect
            />
          </a>
        </div>

      <div
  className="footer-copyright"
  style={{
    animation: "fadeInUp 1s ease-out",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    fontSize: "0.95rem",
  }}
>
  {t('copyright')} © 2025 SPA & GYM.
  <span style={{ margin: "0 10px", display: "flex", alignItems: "center" }}>
    {t('madeWith')}{" "}
    <i
      className="bi bi-heart-fill heartbeat"
      style={{ color: "red", margin: "0 4px" }}
    ></i>{" "}
    {t('by')}
  </span>
  <a
    href="https://perfect1st.com/"
    target="_blank"
    rel="noopener noreferrer"
    className="footer-link"
  >
    {t('companyName')}
    <span className="underline"></span>
  </a>
</div>

    </div>
  );
};

export default Footer;
